import {UI} from "../../../stem-core/src/ui/UIBase";


const MessageValidTags = ["b", "i"];

export class MessageElement extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            message: "",
            args: [],
        }
    }

    static convertStringToUI(value) {
        if (!value) {
            return value;
        }
        for (const tag of MessageValidTags) {
            const tokens = value.split("<" + tag + ">");
            if (tokens.length === 1) {
                continue;
            }
            const TagElement = UI.Primitive(tag);
            const elements = [];
            elements.push(this.convertStringToUI(tokens.shift()));
            for (const token of tokens) {
                const [tagValue, extra] = token.split("</" + tag + ">");
                elements.push(...[<TagElement>{this.convertStringToUI(tagValue)}</TagElement>, this.convertStringToUI(extra)]);
            }
            return elements;
        }
        return value;
    }

    render() {
        const message = typeof this.options.message === "function"
            ? this.options.message(...this.options.args)
            : this.options.message;
        return this.constructor.convertStringToUI(message.toString());
    }
}
